export const prebidTimeout = {
    id: 'PrebidTimeout',
    author: 'Chris Jones (@chrislomaxjones)',
    start: '2021-10-6',
    expiry: '2021-10-29',
    audience: 3 / 100,
    audienceOffset: 0,
    audienceCriteria: 'All users',
    description: 'Vary the length of the prebid timeout beyond which we stop accepting bids. See if varying this timeout leads to any changes in commercial timing metrics',
    successMeasure: 'Varying the length of the prebid timeout has an effect on commercial timing metrics',
    variants: [
        { id: 'variant500', test: () => { } },
        { id: 'variant1500', test: () => { } },
        { id: 'variant4000', test: () => { } },
    ],
    canRun: () => true,
};
